const styles = () => ({
  dialogContent: {
    maxHeight: '80vh',
  },
})

export default styles
